import useProductsFiltered from './useProductsFiltered'

export default useProductsFiltered
